export const THEME_PRESETS = [
  { key: "", label: "Default — SupportPro Green" },
  { key: "learn_purple_red", label: "Purple & Red (LEARN DC)", primary: "#462573", dark: "#371D5C", soft: "#F2EEF7", soft_dark: "#E6DFF1", soft_border: "#D4C8E6", accent: "#DB4634" },
  { key: "navy_blue", label: "Navy Blue", primary: "#1D4ED8", dark: "#1E40AF", soft: "#EBF1FE", soft_dark: "#DBE6FD", soft_border: "#C3D4FB", accent: "#0F1F38" },
  { key: "crimson", label: "Crimson", primary: "#B91C1C", dark: "#991B1B", soft: "#FCEBEB", soft_dark: "#F9DBDB", soft_border: "#F3C3C3", accent: "#132238" },
];

export const GOAL_TYPES = ["Classroom/Academic", "Behavior", "Adaptive", "Clinician"];
export const GOAL_RESULTS = ["Met", "Partially met", "Not met", "Not worked on today", "Student absent"];
export const GOAL_PROMPTS = ["Independent", "Gestural", "Verbal", "Model", "Physical"];
export const NO_PROMPT_RESULTS = ["Not worked on today", "Student absent"];
export const GOAL_SCHEDULES = [["weekly", "Weekly"], ["biweekly", "Every two weeks"], ["monthly", "Monthly"]];
